import { Skeleton, Row, Col } from "antd";
import { CheckBoxDiv, Inner, TableHeader } from "./styles";

const GUTTER = 20;

export default function SkeletonBannersPublicity() {
	return (
		<Inner>
			<Row gutter={GUTTER}>
				<TableHeader>
					<Col span={15} style={{ display: "flex", justifyContent: "center" }}>
						<Skeleton.Image />
					</Col>
					<Col
						span={6}
						style={{ display: "flex", justifyContent: "space-between" }}
					>
						<CheckBoxDiv />
						<CheckBoxDiv />
					</Col>
					<Col span={4}></Col>
				</TableHeader>
			</Row>

			<Row gutter={GUTTER}>
				<TableHeader>
					<Col span={15} style={{ display: "flex", justifyContent: "center" }}>
						<Skeleton.Image />
					</Col>
					<Col
						span={6}
						style={{ display: "flex", justifyContent: "space-between" }}
					>
						<CheckBoxDiv />
						<CheckBoxDiv />
					</Col>
					<Col span={4}></Col>
				</TableHeader>
			</Row>

			<Row gutter={GUTTER}>
				<TableHeader>
					<Col span={15} style={{ display: "flex", justifyContent: "center" }}>
						<Skeleton.Image />
					</Col>
					<Col
						span={6}
						style={{ display: "flex", justifyContent: "space-between" }}
					>
						<CheckBoxDiv />
						<CheckBoxDiv />
					</Col>
					<Col span={4}></Col>
				</TableHeader>
			</Row>
		</Inner>
	);
}
